import { CategoryApplicationConfiguration, CategoryType } from '@era/settings-sdk';

import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface ApplicationConfiguration {
  categoryType: CategoryType;
  categoryId: string;
  displayName: string;
  bundleIdentifier: string;
  version: string;
  applyFrom?: Date;
  applyTill?: Date;
}

export function applicationConfigurationFrom(
  configuration: CategoryApplicationConfiguration
): ApplicationConfiguration {
  return {
    categoryType: configuration.categoryType,
    categoryId: configuration.categoryId,
    displayName: configuration.displayName ?? '',
    bundleIdentifier: configuration.bundleIdentifier,
    version: configuration.version,
    applyFrom: configuration.applyFrom ? new Date(configuration.applyFrom) : undefined,
    applyTill: configuration.applyTill ? new Date(configuration.applyTill) : undefined,
  };
}

export type CategoryApplicationsState = EntityState<ApplicationConfiguration>;

export function selectId(application: ApplicationConfiguration) {
  return `${application.categoryType}-${application.categoryId}-${application.bundleIdentifier}-${application.version}`;
}

export const adapter: EntityAdapter<ApplicationConfiguration> = createEntityAdapter<ApplicationConfiguration>({
  selectId,
});

export const initialState: CategoryApplicationsState = adapter.getInitialState();
